import { render } from "./CreateBlogPostDialog.vue?vue&type=template&id=0a4f2506"
import script from "./CreateBlogPostDialog.vue?vue&type=script&lang=js"
export * from "./CreateBlogPostDialog.vue?vue&type=script&lang=js"

import "./CreateBlogPostDialog.vue?vue&type=style&index=0&id=0a4f2506&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__